import axios from 'axios'
import config from "../config/constants";
import { toastr } from 'react-redux-toastr';
import {loadProcessToken } from "../actions/index";

export const LOAD_GENERATOR_CONFIG = "LOAD_GENERATOR_CONFIG";
export const CREATE_GENERATOR_CONFIG = "CREATE_GENERATOR_CONFIG";

export const loadGeneratorConfig  = (selected_project, selected_model, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        console.log(selected_project);
        var url =null;
        if (selected_model ==null){
          url = config.PROJECT_DASHBOARD_API_URL + 'aiservice/generator/config?project='+selected_project.name + '&storage_type='+ selected_project.storageType+ '&data_type='+ selected_project.dataType;
        } else{
          url = config.PROJECT_DASHBOARD_API_URL + 'aiservice/generator/config?project='+selected_project.name + '&storage_type='+ selected_project.storageType + '&data_type='+ selected_project.dataType + '&selected_model='+ selected_model;
        }
        console.log(url);
        axios.get(url).then(({ data }) => {
            dispatch({
                type: LOAD_GENERATOR_CONFIG,
                payload: data
            });
        }).catch(function (error) {
              toastr.error('Error in loading generator configuration');
        });
    }
}

export const createGeneratorConfig = (props, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        console.log("posting generator config");
        console.log(props);
        axios.post(config.PROJECT_DASHBOARD_API_URL + 'aiservice/generator/config', props).then(({ data }) => {
            toastr.success('Successfully updated the generator config');
             dispatch({
                type: CREATE_GENERATOR_CONFIG,
                payload: data
            });
        }).catch(function (error) {
              toastr.error('Error in saving generator configuration');
        });
    };
}

export const cloneGeneratorConfig  = (dst_project, src_project, scope) => {
    let token = loadProcessToken();
    return (dispatch, getState) => {
        var url = config.PROJECT_DASHBOARD_API_URL + 'aiservice/generator/clone?project='+dst_project.name + '&storage_type='+ dst_project.storageType+ '&data_type='+ dst_project.dataType+ '&src_project='+ src_project.name;
        console.log(url);
        axios.get(url).then(({ data }) => {
            dispatch({
                type: LOAD_GENERATOR_CONFIG,
                payload: data
            });
        }).catch(function (error) {
              toastr.error('Error in cloning generator configuration');
        });
    }
}



// WEBPACK FOOTER //
// ./src/actions/generators.js